import React, { useState } from 'react';
import moment from 'moment';
import CollapsiblePanel from '../../../../formInputsV2/CollapsiblePanel';
import { mediciLiberiProfessionistiRetroactivities, professionEmployeeTypes } from '../../../../constants';
import { Card, AlwaysOpenAtDesktop } from './shared.styles';
import {
  Header, Title, ModificaButton, CompactSummary, InfoList, InfoRow,
} from './VehicleSummaryCard.styles';
import editIcon from '../../../../../assets/redesign_icons/edit-icon.svg';

function RcProfessionaleSanitaSummaryCard({ customer, insuranceRequest, modifyData }) {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const data = insuranceRequest.insurance_request_profession_sanita;

  const hasMlpRetroactivity = data.mlp_activities !== null
    && data.mlp_activities.length > 0
    && mediciLiberiProfessionistiRetroactivities.find(
      (el) => el.id === data.mlp_activities[0].retroactivity,
    ) !== undefined;

  const hasPlainRetroactivity = (data.mlp_activities === null || data.mlp_activities.length === 0)
    && data.retroactivity;

  return (
    <Card>
      <Header>
        <Title>Professioni Sanitarie e Mediche</Title>
        {modifyData && (
          <ModificaButton type="button" onClick={() => modifyData()}>
            Modifica Dati
            <img src={editIcon} alt="" />
          </ModificaButton>
        )}
      </Header>

      <CompactSummary>
        {customer.name}
        {' '}
        {customer.surname}
      </CompactSummary>

      <AlwaysOpenAtDesktop>
        <CollapsiblePanel
          open={detailsOpen}
          onToggle={() => setDetailsOpen((open) => !open)}
          instructionText=""
          openLabel="Nascondi dettagli"
          closedLabel="Dettagli"
        >
          <InfoList>
            <InfoRow>
              <dt>Contraente</dt>
              <dd>
                {customer.name}
                {' '}
                {customer.surname}
              </dd>
            </InfoRow>
            {data.employee_type && (
              <InfoRow>
                <dt>Dipendente</dt>
                <dd>
                  {professionEmployeeTypes.find((el) => el.id === data.employee_type).name}
                </dd>
              </InfoRow>
            )}
            {data.health_profession_id && (
              <InfoRow>
                <dt>Attività</dt>
                <dd>{data.health_profession.name}</dd>
              </InfoRow>
            )}
            {hasMlpRetroactivity && (
              <InfoRow>
                <dt>Retroattivita</dt>
                <dd>
                  {mediciLiberiProfessionistiRetroactivities.find(
                    (el) => el.id === data.mlp_activities[0].retroactivity,
                  ).name}
                </dd>
              </InfoRow>
            )}
            {hasPlainRetroactivity && (
              <InfoRow>
                <dt>Retroattivita</dt>
                <dd>{data.retroactivity === '10_anni' ? '10 Anni' : 'Illimitata'}</dd>
              </InfoRow>
            )}
            {data.medico_protetto_activity && (
              <>
                <InfoRow>
                  <dt>Tipo</dt>
                  <dd>
                    {data.medico_protetto_activity.activity_type === 'chirurgical' ? 'Chirurgical' : 'Non Chirurgical'}
                  </dd>
                </InfoRow>
                <InfoRow>
                  <dt>Attivita</dt>
                  <dd>{data.medico_protetto_activity.name}</dd>
                </InfoRow>
              </>
            )}
            <InfoRow>
              <dt>Numero Iscrizione Albo</dt>
              <dd>{data.albo_registration_number ? data.albo_registration_number : 'N/A'}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Inizio Copertura</dt>
              <dd>{moment(insuranceRequest.policy_effective_date).format('DD-MM-YYYY')}</dd>
            </InfoRow>
          </InfoList>
        </CollapsiblePanel>
      </AlwaysOpenAtDesktop>
    </Card>
  );
}

export default RcProfessionaleSanitaSummaryCard;
